export default __webpack_public_path__ + "static/media/after.7bc21edc.png";